import dynamic from 'next/dynamic';

import {SeriesData} from 'components/v2/charts/AreaChart';

export const Chart = ({
  labels,
  data,
  chartOpts,
}: {
  labels: Array<string>;
  data: SeriesData[];
  width?: number;
  height?: number;
  chartOpts?: any;
}) => {
  const Chart = dynamic(() => import('react-apexcharts'), {ssr: false});

  return (
    <>
      {typeof window !== 'undefined' && data && (
        <Chart
          width={'100%'}
          height={'100%'}
          options={{
            chart: {
              height: 350,
              type: 'line',
              zoom: {
                enabled: false,
              },
              background: 'transparent',
              toolbar: {
                show: false,
              },
            },
            dataLabels: {
              enabled: false,
            },
            stroke: {
              curve: 'straight',
              colors: ['#BBCAE3'],
              width: 1,
            },
            grid: {
              show: false,
              row: {
                colors: ['transparent', 'transparent'], // takes an array which will be repeated on columns
                opacity: 0.5,
              },
            },
            yaxis: {
              labels: {
                show: false,
              },
            },
            xaxis: {
              labels: {
                show: false,
              },
              categories: labels,
            },
            fill: {
              type: 'solid',
              colors: ['transparent'],
            },
            ...(chartOpts || {}),
          }}
          type={'area'}
          series={data}
        />
      )}
    </>
  );
};
